function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLightningAvacon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lightning_avacon",
    transform: "matrix(0.973218,0,0,0.973218,0.703693,0.656195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.836,25.851C32.563,24.978 31.857,24.343 30.967,24.149L23.126,22.473L29.644,9.446C29.714,9.296 29.67,9.111 29.529,9.023C29.388,8.926 29.203,8.952 29.097,9.084L17.657,22.279C17.067,22.958 16.89,23.867 17.172,24.722C17.455,25.569 18.143,26.195 19.016,26.38L27.298,28.188L27.606,27.58L19.157,25.736C18.513,25.595 18.001,25.137 17.799,24.51C17.587,23.884 17.719,23.205 18.16,22.711L27.88,11.501L22.35,22.552C22.306,22.641 22.306,22.755 22.35,22.844C22.394,22.932 22.482,23.002 22.579,23.029L30.834,24.793C31.496,24.934 32.007,25.401 32.21,26.045C32.413,26.689 32.263,27.368 31.805,27.862L21.812,38.64L26.292,30.146L25.622,29.996L20.056,40.554C19.977,40.704 20.021,40.88 20.162,40.977C20.224,41.021 20.286,41.039 20.356,41.039C20.445,41.039 20.533,41.004 20.603,40.933L32.298,28.321C32.907,27.65 33.119,26.724 32.836,25.851Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.03px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLightningAvacon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lightning_avacon.a72c291b.svg";
export { ForwardRef as ReactComponent };